import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Experiment`}</h1>
    <h2>{`Check variation`}</h2>
    <p>{`Check which variation of an experiment is assigned to a user.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-kt"
      }}>{`val experimentId = "experiment-1"

tesfyEngine.getVariationId(experimentId, null) // "1"
`}</code></pre>
    <p>{`A `}<inlineCode parentName="p">{`userId`}</inlineCode>{` and `}<inlineCode parentName="p">{`attributes`}</inlineCode>{` could be optionally supplied.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`val experimentId = "experiment-2"
val userId = "676380e0-7793-44d6-9189-eb5868e17a86"
val attributes = mapOf("countryCode" to "us")

tesfyEngine.getVariationId(experimentId, userId, attributes) // "1"
`}</code></pre>
    <h2>{`Set forced variation`}</h2>
    <p>{`Set a fixed variation for a given experiment. Helpful functionality if you want to do tests.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-kt"
      }}>{`val experimentId = "experiment-1"
val variationId = "3"

tesfyEngine.setForcedVariation(experimentId: experimentId, variationId: variationId)
tesfyEngine.getVariationId(experimentId: experimentId) // "3"
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      